import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where, orderBy, limit } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { Scale, Zap, ArrowRight, Star } from 'lucide-react'; 
import { motion, AnimatePresence } from 'framer-motion';

import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

import '../../components/subPages.css';
import '../CategoryCards/CategoryCards.css';
import '../CategoryDetail/CategoryDetail.css'; 
import { db } from '../firebase/firebase-config';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const YemKatkilari = () => {
  const [products, setProducts] = useState([]);
  const [heroImage, setHeroImage] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { lang } = useLanguage();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sliderSnap = await getDocs(query(collection(db, "sliders"), orderBy("createdAt", "desc"), limit(1)));
        if (!sliderSnap.empty) {
          setHeroImage(sliderSnap.docs[0].data().url);
        }

        // Kanka panelde kategori adını "Yem Katkıları" olarak tuttuğun için sorgu sabit kalmalı
        const q = query(
          collection(db, "products"), 
          where("categoryName", "==", "Yem Katkıları")
        );
        const prodSnap = await getDocs(q);
        setProducts(prodSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));

      } catch (error) {
        console.error("Veri yükleme hatası:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // KANKA: Firebase'den gelen ürün verisini dile göre seçen yardımcı fonksiyon
  const getProdName = (prod) => {
    if (lang === 'AR') return prod.nameAr || prod.nameEn || prod.name;
    if (lang === 'EN') return prod.nameEn || prod.name;
    return prod.name;
  };

  return (
    <div className="subpage-wrapper">
      <Navbar />
      
      {/* DINAMIK HERO */}
      <section className="subpage-hero">
        <motion.div 
          initial={{ scale: 1.1, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 2 }}
          className="hero-bg-image"
          style={{ backgroundImage: `url(${heroImage || '/default-hero.jpg'})` }}
        />
        <div className="hero-overlay" style={{ background: 'linear-gradient(to bottom, rgba(26, 71, 49, 0.85), rgba(26, 71, 49, 0.65))' }}>
          <motion.div initial={{ y: -20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}>
            <div className="category-badge" style={{ marginBottom: '15px' }}>
              {lang === 'TR' ? "Bigma Özel Çözümler" : lang === 'AR' ? "حلول بيغما الخاصة" : "Bigma Special Solutions"}
            </div>
            <h1 style={{ color: '#fff' }}>
              {lang === 'TR' ? "Yem Katkıları" : lang === 'AR' ? "إضافات الأعلاف" : "Feed Additives"}
            </h1>
            <div className="hero-sub-badge">
              {lang === 'TR' ? "Yüksek Verim, Bilimsel Destek" : lang === 'AR' ? "إنتاجية عالية، دعم علمي" : "High Yield, Scientific Support"}
            </div>
          </motion.div>
        </div>
      </section>

      {/* ÜRÜN LİSTESİ */}
      <section className="product-grid-container" style={{ padding: '80px 0' }}>
        <div className="container">
          <AnimatePresence mode="wait">
            {products.length > 0 ? (
              <div className="product-list-grid">
                {products.map((prod, index) => (
                  <motion.div 
                    key={prod.id} 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.05 }}
                    className="product-premium-card"
                    onClick={() => navigate(`/urun/${prod.id}`, { state: { product: prod } })}
                  >
                    {prod.isBestSeller && (
                      <div className="best-seller-tag">
                        <Star size={12} fill="white" /> {lang === 'TR' ? "Çok Satan" : lang === 'AR' ? "الأكثر مبيعاً" : "Best Seller"}
                      </div>
                    )}
                    
                    <div className="prod-img-box">
                      <img src={prod.imageUrl} alt={getProdName(prod)} />
                    </div>

                    <div className="prod-content">
                      <span className="prod-category-label">
                        {lang === 'TR' ? "Yem Katkısı" : lang === 'AR' ? "إضافة علفية" : "Feed Additive"}
                      </span>
                      <h3 style={{ color: '#1a4731', fontWeight: '800' }}>
                        {getProdName(prod)}
                      </h3>
                      
                      <div className="prod-tech-tags">
                        <div className="tech-tag">
                          <Scale size={14} /> {prod.weight} {lang === 'AR' ? "كجم" : "KG"}
                        </div>
                        <div className="tech-tag">
                          <Zap size={14} /> 
                          {lang === 'TR' ? (prod.type || 'Toz/Pelet') : 
                           lang === 'AR' ? (prod.typeAr || prod.typeEn || 'مسحوق/مكبوس') : 
                           (prod.typeEn || 'Powder/Pellet')}
                        </div>
                      </div>

                      <button className="view-analyze-btn">
                        {lang === 'TR' ? "İncele" : lang === 'AR' ? "عرض" : "Examine"} <ArrowRight size={18} />
                      </button>
                    </div>
                  </motion.div>
                ))}
              </div>
            ) : (
              <div className="no-products-info" style={{ textAlign: 'center', padding: '100px 0', color: '#64748b', fontWeight: '700' }}>
                {lang === 'TR' ? "Henüz yem katkısı ürünü eklenmemiş." : lang === 'AR' ? "لم يتم إضافة أي منتجات إضافات علفية بعد." : "No feed additive products have been added yet."}
              </div>
            )}
          </AnimatePresence>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default YemKatkilari;